<style lang="scss" scoped>
.sale-warp {
  display: flex;
  .sale-item {
    min-width: 150px;
    text-align: center;
    padding: 10px;
    border: 1px solid #ded;
    margin: 5px;
    cursor: pointer;
    &:active {
      transform: scale(0.8, 0.8);
      transition: 0.1s;
    }
    &:hover {
      border-color: #2d8cf0;
    }
    &.act {
      background: #2d8cf0;
      color: #fff;
      border-color: #fff;
      .info {
        color: #fff;
      }
    }
    .name {
      border-bottom: 1px solid #dedede;
      font-weight: 600;
      font-size: 18px;
      padding: 0 5px;
      padding-bottom: 2px;
    }
    .info {
      font-size: 12px;
      padding: 0 5px;
      padding-top: 5px;
      color: #494949;
    }
  }
}
.pay-warp {
  display: flex;
  .pay-item {
    padding: 10px 20px;
    border: 1px solid #ded;
    margin: 5px;
    cursor: pointer;
    width: 120px;
    height: 50px;
    &:active {
      transform: scale(0.8, 0.8);
      transition: 0.1s;
    }
    &:hover {
      border-color: #2d8cf0;
    }
    &.act {
      border-color: #2d8cf0;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.list-warp {
  display: flex;
  label {
    width: 150px;
  }
  span {
    flex: 1;
  }
  .icon {
    width: 25px;
    height: 25px;
  }
}
.modal-warp {
  display: flex;
  .info-warp {
    flex: 1;
  }
  .qrcode-warp {
    width: 200px;
    height: 200px;
    background: red;
  }
}
</style>
<template>
  <div>
    <Divider orientation="center">充值</Divider>
    <Alert>欢迎使用系统充值,目前本平台支持微信和支付宝</Alert>
    <Alert type="error">
      <div style="padding-bottom: 5px"><h3>注意</h3></div>
      <div>购买类型一旦选择则无法更改,请谨慎操作!</div>
      <div>VIP用户 用于使用易回复高级功能</div>
      <div>翻译字符数 用于易回复字符翻译</div>
      <div>VIP用户充值与翻译字符数购买充值互相独立</div>
    </Alert>
    <div v-for="sale in monthSales" :key="sale.label">
      <Divider orientation="left">{{ sale.label }}</Divider>
      <div class="sale-warp">
        <div
          class="sale-item"
          :class="{ act: selected.id == item.id }"
          v-for="item in sale.list"
          :key="item.id"
          @click="selectedSale(item)"
        >
          <div class="name">{{ item.name }}</div>
          <div class="info">
            <div v-if="item.memberDays == -1">永久</div>
            <div v-else>{{ item.memberDays }} 天</div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="sale in charSales" :key="sale.label">
      <Divider orientation="left">{{ sale.label }}</Divider>
      <div class="sale-warp">
        <div
          class="sale-item"
          :class="{ act: selected.id == item.id }"
          v-for="item in sale.list"
          :key="item.id"
          @click="selectedSale(item)"
        >
          <div class="name">{{ item.name }}</div>
          <div class="info">
            <div v-if="item.translationBillingMode == 'char'">
              <span v-if="item.num <= 9999">{{ item.num }} 个字符</span>
              <span v-else>{{ item.num / 10000 }} 万字符</span>
            </div>
            <div v-else>{{ (item.num / 60 / 24 / 30).toFixed(0) }} 个月</div>
          </div>
        </div>
      </div>
    </div>
    <Divider orientation="left">充值数量</Divider>
    <Input-number
      style="width: 200px"
      :min="1"
      v-model="saleNum"
    ></Input-number>
    <Divider orientation="left">支付方式</Divider>
    <div class="pay-warp">
      <div
        v-if="wechatEnable"
        class="pay-item"
        :class="{ act: payType == 'WC_NATIVE' }"
        @click="selectedPayType('WC_NATIVE')"
      >
        <img src="@/assets/wechat.png" />
      </div>

      <div
        v-if="aliEnable"
        class="pay-item"
        :class="{ act: payType == 'ALI_NATIVE' }"
        @click="selectedPayType('ALI_NATIVE')"
      >
        <img src="@/assets/alipay.png" />
      </div>
    </div>
    <div v-if="selected.id">
      <Divider orientation="left">订单详情</Divider>
      <div>
        <div class="list-warp">
          <label>会员组类型</label>
          <span>
            {{
              selected.translationBillingMode == "char"
                ? "字符会员"
                : "包月会员"
            }}
          </span>
        </div>
        <div class="list-warp">
          <label>会员组名称</label>
          <span>{{ selected.name }}</span>
        </div>
        <div class="list-warp">
          <label>{{ selected.type == "replay" ? "会员时间" : "字符数" }}</label>
          <span v-if="selected.translationBillingMode == 'char'"
            >{{ (selected.num * saleNum) / 10000 }}万字</span
          >
          <span v-else-if="selected.memberDays == -1">永久</span>
          <span v-else> {{ selected.memberDays }} 天</span>
        </div>
        <div class="list-warp" v-if="selected.translationBillingMode == 'time'">
          <label>包月数</label>
          <span
            >{{
              new Number((selected.num / 60 / 24 / 30).toFixed(0)) * saleNum
            }}个月</span
          >
        </div>
        <div class="list-warp">
          <label>支付金额</label>
          <span style="color: red; font-size: 20px; font-weight: 600"
            >¥{{ (selected.salePrice * saleNum) / 100 }}元</span
          >
        </div>
        <Divider />
        <Button
          v-if="payType"
          :loading="loading"
          type="primary"
          @click="
            () => {
              this.selected.type === 'replay' ? this.replayPay() : this.pay();
            }
          "
          >立即支付</Button
        >
      </div>
    </div>

    <Modal
      :mask-closable="false"
      :closable="false"
      v-model="modal.show"
      title="请扫码支付(请尽快支付，5分钟后将自动关闭二维码页面)"
      :width="630"
      @on-visible-change="modalChange"
    >
      <div class="modal-warp">
        <div class="info-warp">
          <div>
            <div class="list-warp">
              <label>支付渠道</label>
              <span>
                <img
                  v-if="payType == 'ALI_NATIVE'"
                  class="icon"
                  src="@/assets/ali.png"
                />
                <img v-else class="icon" src="@/assets/wc.png" />
              </span>
            </div>
            <div class="list-warp">
              <label>订单号</label>
              <span>
                {{ modal.orderNo }}
              </span>
            </div>
            <div class="list-warp">
              <label>支付金额</label>
              <span style="color: red"
                >¥{{ (selected.salePrice * saleNum) / 100 }}元</span
              >
            </div>
            <div style="padding-right: 45px"><Divider /></div>
            <div class="list-warp">
              <label>会员组类型</label>
              <span>
                {{
                  selected.translationBillingMode == "char"
                    ? "字符会员"
                    : "包月会员"
                }}
              </span>
            </div>
            <div class="list-warp">
              <label>会员组名称</label>
              <span>{{ selected.name }}</span>
            </div>
            <div class="list-warp">
              <label>{{
                selected.type == "replay" ? "会员时间" : "字符数"
              }}</label>
              <span v-if="selected.translationBillingMode == 'char'"
                >{{ (selected.num * saleNum) / 10000 }}万字</span
              >
              <span v-else-if="selected.memberDays == -1">永久</span>
              <span v-else> {{ selected.memberDays }} 天</span>
            </div>
            <div
              class="list-warp"
              v-if="selected.translationBillingMode == 'time'"
            >
              <label>包月数</label>
              <span
                >{{
                  new Number((selected.num / 60 / 24 / 30).toFixed(0)) *
                  saleNum
                }}个月</span
              >
            </div>
          </div>
        </div>
        <div class="qrcode-warp">
          <div id="qrcode"></div>
        </div>
      </div>
    </Modal>
    <Modal
      :mask-closable="false"
      v-model="tipModal.show"
      title="温馨提示"
      :width="300"
      ok-text="已完成充值"
      cancel-text="未完成"
      @on-visible-change="tipModalChange"
      @on-ok="tipModalOk"
      @on-cancel="tipModalCancel"
    >
      <div>请问您是否已经完成充值?</div>
    </Modal>
    <div ref="alipayWap" v-html="alipay" />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

import userService from "@/service/user";
import memberGroupService from "@/service/member/group";
import orderBymemberGroupService from "@/service/order/memberGroup";
export default {
  name: "UserCenterRecharge",
  data() {
    return {
      alipay: "",
      loading: false,
      userInfo: {
        memberGroup: {},
        memberAccount: {},
        lastLoginLog: {},
      },
      charSales: [],
      monthSales: [],
      selected: {},
      saleNum: 1,
      payType: "WC_NATIVE",
      modal: {
        show: false,
        url: "",
        orderId: 0,
        orderNo: "",
      },
      tipModal: {
        show: false,
      },
      iid: 0,
      aliEnable: false,
      wechatEnable: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadUserInfo();
      this.loadSales();
      this.loadPayChannel();
      this.loadMonthSales();
    },
    async loadUserInfo() {
      this.userInfo = await userService.get();
    },
    async loadMonthSales() {
      let sales = await memberGroupService.monthSaleList();
      let time = { label: "VIP用户", list: [] };
      for (let i = 0; i < sales.length; i++) {
        let item = sales[i];
        let target = time;
        item.type = "replay"; //区分易回复还是易翻译
        if (item.id !== 7) {
          target.list.push(item);
        }
      }
      this.monthSales.push(time);
    },
    async loadSales() {
      let sales = await memberGroupService.saleList();
      let char = { label: "翻译字符数", list: [] };
      for (let i = 0; i < sales.length; i++) {
        let item = sales[i];
        let target = char;
        let targetIdArr = [2, 3, 4];
        if (targetIdArr.includes(item.id)) {
          target.list.push(item);
        }
      }
      this.charSales.push(char);
    },
    async loadPayChannel() {
      let channels = await orderBymemberGroupService.getPayChannels();
      for (let i = 0; i < channels.length; i++) {
        if (channels[i] === "ali") {
          this.aliEnable = true;
        }
        if (channels[i] === "wechat") {
          this.wechatEnable = true;
        }
      }
    },
    selectedSale(item) {
      this.selected = item;
    },
    selectedPayType(payType) {
      this.payType = payType;
    },
    qpsRateFmt(item) {
      if (!item || !item.qpsRate) {
        return "无限制";
      }
      let arr = JSON.parse(item.qpsRate);
      let sec = arr[0];
      let min = arr[1];
      if (!sec && !min) {
        return "无限制";
      }
      return (
        "每秒 " +
        ((sec ? sec : "无限制") + " 次") +
        "," +
        "每分 " +
        ((min ? min : "无限制") + " 次")
      );
    },
    //字符数支付
    async pay() {
      let params = {
        memberGroupId: this.selected.id,
        salesNum: this.saleNum,
        payChannel: this.payType,
      };
      this.loading = true;
      let result = await orderBymemberGroupService.pay(params);
      if (!result) {
        this.loading = false;
        return;
      }
      this.toPayPage(result);
    },
    //易回复支付
    async replayPay() {
      let params = {
        memberGroupId: this.selected.id,
        salesNum: this.saleNum,
        payChannel: this.payType,
      };
      this.loading = true;
      let result = await orderBymemberGroupService.replyPay(params);
      if (!result) {
        this.loading = false;
        return;
      }
      this.toPayPage(result);
    },
    toPayPage(payInfo) {
      if (this.$data.payType === "ALI_NATIVE") {
        // 渲染支付页面
        this.alipay = payInfo.scanQRCodeUrl;
        console.log(this.alipay);
        // 防抖避免重复支付
        this.$nextTick(() => {
          // 提交支付表单
          console.log(this.$refs.alipayWap.children[0]);
          this.$refs.alipayWap.children[0].acceptCharset = "GBK";
          this.$refs.alipayWap.children[0].submit();
          setTimeout(() => {
            // this.toPayFlag = false;
          }, 500);
        });
        return;
      }
      let qrCodeUrl = payInfo.scanQRCodeUrl;
      this.modal.show = true;
      this.modal.orderId = payInfo.orderId;
      this.modal.orderNo = payInfo.orderNo;
      this.modal.url = qrCodeUrl;
      window.document.getElementById("qrcode").innerHTML = "";
      new QRCode("qrcode", {
        width: 200,
        height: 200,
        text: qrCodeUrl,
      });
      window.clearInterval(this.iid);
      window.clearTimeout(this.tid);
      this.iid = window.setInterval(() => {
        this.queryOrderPayInfo();
      }, 500);

      this.tid = window.setTimeout(() => {
        this.modal.show = false;
      }, 5 * 60 * 1000);
    },
    async queryOrderPayInfo() {
      let payInfo = null;
      if (this.selected.type == "replay") {
        payInfo = await orderBymemberGroupService.getReplayPayInfo(
          this.modal.orderId
        );
      } else {
        payInfo = await orderBymemberGroupService.getPayInfo(
          this.modal.orderId
        );
      }
      if (payInfo && payInfo.payStatus == "P") {
        this.paySuccess(payInfo);
      }
    },
    paySuccess(payInfo) {
      window.clearInterval(this.iid);
      window.clearTimeout(this.tid);
      let str = encodeURIComponent(JSON.stringify(payInfo));
      this.$router.push({ name: "PaySuccess", query: { payInfo: str } });
    },
    modalChange(e) {
      if (e) {
        return;
      }
      this.tipModal.show = true;
    },
    async tipModalOk() {
      window.clearInterval(this.iid);
      window.clearTimeout(this.tid);
      this.loading = true;
      let result = null;
      if (this.selected.type == "replay") {
        result = await orderBymemberGroupService.replayFlush(this.modal.orderId);
      } else {
        result = await orderBymemberGroupService.flush(this.modal.orderId);
      }
      if (result) {
        this.queryOrderPayInfo();
      }
      this.loading = false;
    },
    tipModalCancel() {
      window.clearInterval(this.iid);
      window.clearTimeout(this.tid);
    },
    tipModalChange(e) {
      if (e) {
        return;
      }
      this.loading = false;
    },
  },
  beforeUnmount() {
    window.clearInterval(this.iid);
    window.clearTimeout(this.tid);
  },
};
</script>

